import ParkingMetersPage from './components/ParkingMetersPage';
import StatusHistoryPage from './components/StatusHistoryPage';
import MobileParkingMetersPage from './components/MobileParkingMetersPage';
import Empty from '../../components/base/Empty';

const routes = [
  {
    path: '/parking-meters',
    name: 'menu.parking.meters',
    icon: 'battery-alert',
    customIcon: true,
    loginRequired: true,
    component: ParkingMetersPage,
    weight: 1,
    permission: ['frontend_menu_parkomat'],
    children: [],
  },
  {
    path: '/parking-meters',
    name: 'menu.parking.meters',
    icon: 'battery-alert',
    customIcon: true,
    loginRequired: true,
    component: MobileParkingMetersPage,
    weight: 1,
    permission: ['frontend_menu_parkomat'],
    children: [],
    forMobile: true,
  },
  {
    path: '/status-history',
    name: 'menu.status.history',
    icon: 'history',
    customIcon: true,
    loginRequired: true,
    component: StatusHistoryPage,
    weight: 1,
    permission: ['frontend_menu_history'],
    children: [],
  },
  {
    path: '/status-history',
    to: 'parking-meters',
    name: 'menu.dashboard',
    icon: 'dashboard',
    customIcon: true,
    loginRequired: true,
    component: Empty,
    weight: 1,
    permission: [],
    children: [],
    forMobile: true,
    redirect: true,
  },
];

export default routes;
